<template>
  <div class="text-right dropdown-menus">
    <template v-for="menu in menus">
      <v-menu offset-y :open-on-hover="true" :key="menu.title">
        <template v-slot:activator="{ on }">
          <v-btn v-if="menu.children" class="custom-menu-btn" dark v-on="on">{{
            menu.title
          }}</v-btn>
          <v-btn
            v-else
            class="custom-menu-btn"
            dark
            v-on="on"
            @click="goTo(menu.title)"
            >{{ menu.title }}</v-btn
          >
        </template>
        <v-list max-width="150px" v-if="menu.children">
          <v-list-item
            v-for="item in menu.children"
            :key="item.title"
            @click="goTo(item.title)"
          >
           {{ item.title }}
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { menus } from "../../utils/constants";

export default {
  data: () => ({
    menus: menus,
  }),
  methods: {
    goTo(name) {
      if(name == "Interaction Lab"){
        window.open("https://uscinteractionlab.web.app/","_blank")
      } else if (name == "Students"){
        window.open("https://uscinteractionlab.web.app/about/people", "_blank");
      } else if (name == "Publications"){
        window.open("https://uscinteractionlab.web.app/research/publications","_blank");
      } else if (name == "Google Scholar Profile"){
        window.open("https://scholar.google.com/citations?user=o5YQMkMAAAAJ&hl=en","_blank");
      }
      // else if (name == "Videos"){
      //   window.open("https://uscinteractionlab.web.app/media/videos","_blank");
      // }
      else if (name == "Media Coverage"){
        window.open("https://uscinteractionlab.web.app/media/media%20coverage","_blank");
      } else if (name == "Movie"){
        window.open("https://www.rottentomatoes.com/m/me_and_isaac_newton","_blank");
      } else if (name == "Book"){
        window.open("https://mitpress.mit.edu/9780262633543/the-robotics-primer/","_blank");
      }
      else {
        this.$router.push({ name }).catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss">
.dropdown-menus {
  text-align: right !important;
  display: block !important;
}
.custom-menu-btn {
  margin: 0 2px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  background-color: #990000 !important;
}

/**
 * following are responsive support
 */
@media (max-width: 1100px) {
  .dropdown-menus {
    display: none !important;
  }
}
</style>
